(function () {
  var FREE_GIFT_PROPERTY = '_free_gift';

  var OFFERS = [
    {
      freeVariantId: 53209915424992,
      rules: [
        { variantId: 48197988384992, minQty: 24 },
        { variantId: 48197988417760, minQty: 6 },
        { variantId: 48197988450528, minQty: 1 },
      ],
    },
    {
      freeVariantId: 53209902874848,
      rules: [
        { variantId: 48197996478688, minQty: 24 },
        { variantId: 48197996511456, minQty: 6 },
        { variantId: 48197996544224, minQty: 1 },
      ],
    },
  
  ];

  var CART_WRITE_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var isProcessing = false;
  var pendingSync = false;
  var debounceTimer = null;

  // ─────────────────────────────────────────────────────────────

  // function getVariantQty(items, variantId) {
  //   var total = 0;
  //   items.forEach(function (item) {
  //     if (item.variant_id === variantId) total += item.quantity;
  //   });
  //   return total;
  // }

  function getVariantQty(items, variantId) {
  var total = 0;

  items.forEach(function (item) {
    // Ignore free gift lines
    if (
      item.variant_id === variantId &&
      !(
        item.properties &&
        item.properties[FREE_GIFT_PROPERTY] === 'true'
      )
    ) {
      total += item.quantity;
    }
  });

  return total;
}

  function getRequiredFreeQty(items, offer) {
    var totalFreeQty = 0;
    offer.rules.forEach(function (rule) {
      var qty = getVariantQty(items, rule.variantId);
      if (qty >= rule.minQty) totalFreeQty += Math.floor(qty / rule.minQty);
    });
    return totalFreeQty;
  }

  // Returns ALL lines for the free gift (not just the first)
  function getAllFreeGiftLines(items, freeVariantId) {
    return items.filter(function (item) {
      return (
        item.variant_id === freeVariantId &&
        item.properties &&
        item.properties[FREE_GIFT_PROPERTY] === 'true'
      );
    });
  }

  // Keep the line that has the Shopify discount applied; fall back to the first line
  function pickPrimaryLine(lines) {
    if (!lines.length) return null;
    var discounted = lines.find(function (g) {
      return (
        g.final_price === 0 ||
        (g.line_level_discount_allocations && g.line_level_discount_allocations.length > 0)
      );
    });
    return discounted || lines[0];
  }

  function nativeFetch(url, opts) {
    return _nativeFetch.call(window, url, opts);
  }

  function cartPostJSON(url, data) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart request failed: ' + r.status);
      return r.json();
    });
  }

  function addFreeGift(variantId, qty) {
    var props = {};
    props[FREE_GIFT_PROPERTY] = 'true';
    return cartPostJSON('/cart/add.js', {
      items: [{ id: variantId, quantity: qty, properties: props }],
    });
  }

  function updateFreeGift(lineKey, qty) {
    // Do NOT include properties — sending them can strip the Shopify
    // automatic-discount allocation that's tied to the existing line.
    return cartPostJSON('/cart/change.js', { id: lineKey, quantity: qty });
  }

  function removeFreeGift(lineKey) {
    return cartPostJSON('/cart/change.js', { id: lineKey, quantity: 0 });
  }

  // ─────────────────────────────────────────────────────────────

  function syncFreeGifts() {
    if (isProcessing) {
      pendingSync = true;
      return;
    }

    isProcessing = true;
    pendingSync = false;

    nativeFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var ops = [];

        OFFERS.forEach(function (offer) {
          var requiredQty = getRequiredFreeQty(items, offer);

          // Collect every free-gift line for this offer
          var allLines = getAllFreeGiftLines(items, offer.freeVariantId);

          // Keep the discounted line; it already has the Shopify discount allocation
          var primary = pickPrimaryLine(allLines);

          // Remove every line that isn't the primary (the duplicates causing the inflated qty)
          allLines.forEach(function (line) {
            if (line.key !== (primary ? primary.key : null)) {
              ops.push(removeFreeGift(line.key));
            }
          });

          if (!primary && requiredQty > 0) {
            ops.push(addFreeGift(offer.freeVariantId, requiredQty));
            return;
          }

          if (primary && requiredQty === 0) {
            ops.push(removeFreeGift(primary.key));
            return;
          }

          if (primary && primary.quantity !== requiredQty) {
            ops.push(updateFreeGift(primary.key, requiredQty));
          }
        });

        return ops.length
          ? Promise.all(ops).then(function () { return true; })
          : false;
      })
      .then(function (mutated) {
        if (!mutated) return;

        if (window.MinimogTheme && window.MinimogTheme.Cart) {
          window.MinimogTheme.Cart.refreshCart().then(function () {
            window.MinimogTheme.Cart.renderNewCart();
          });
        }

        if (window.corner && typeof window.corner.do === 'function') {
          window.corner.do('refreshCart');
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (err) {
        console.error('[FreeGiftAutomation]', err);
      })
      .finally(function () {
        isProcessing = false;
        if (pendingSync) {
          pendingSync = false;
          scheduleSync();
        }
      });
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncFreeGifts, 300);
  }

  // ─────────────────────────────────────────────────────────────
  // FETCH INTERCEPT
  // ─────────────────────────────────────────────────────────────

  var _nativeFetch = window.fetch;

  window.fetch = function (resource, init) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var method = ((init && init.method) || 'GET').toUpperCase();
    var isCartWrite = CART_WRITE_PATTERN.test(url) && method !== 'GET';
    var result = _nativeFetch.apply(window, arguments);

    if (isCartWrite) {
      result
        .then(function (response) {
          if (response.ok) scheduleSync();
          return response;
        })
        .catch(function () {});
    }

    return result;
  };

  // ─────────────────────────────────────────────────────────────
  // XHR INTERCEPT (CornerCart)
  // ─────────────────────────────────────────────────────────────

  var _XHROpen = XMLHttpRequest.prototype.open;
  var _XHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._fgaMethod = method ? method.toUpperCase() : 'GET';
    this._fgaUrl = url || '';
    return _XHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (CART_WRITE_PATTERN.test(self._fgaUrl) && self._fgaMethod !== 'GET') {
      self.addEventListener('load', function () {
        if (self.status >= 200 && self.status < 300) scheduleSync();
      });
    }
    return _XHRSend.apply(this, arguments);
  };

  scheduleSync();
})();